export default __webpack_public_path__ + "static/swift-2dc1ab2c05b8fe0e83f867cff6998839.svg";